var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"left"},[_vm._t("header-left")],2),_c('div',{staticClass:"right"},[_vm._t("header-right")],2)]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }